<template>
    <div class="row" style="margin: 0;">
        <div class="col-sm-12" style="padding-top: 0;padding-bottom: 5px;">
            <div class="d-flex flex-row align-items-center">
                <div class="bd-highlight flex-grow-1">
                    <div style="font-size:medium; font-weight: 600;">
                        XSTEK LIMTED<small style="margin-left: 10px;font-size: 10pt;font-weight: 400;margin-top: 1px;">{{welcome}}</small>
                    </div>
                </div>
                <div class="bd-highlight">
                    <div>{{windowDate}}</div>
                    <div class="text-right">
                        <button ref="logout" type="button" class="btn btn-sm btn-danger" @click="logout">
                            <i class="fas fa-sign-out-alt"></i>&nbsp;Logout
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12" style="padding-top: 0;padding-bottom: 0;">
            <div class="d-flex flex-row align-items-center" style="background-color: rgb(217, 233, 248);">
                <div class="bd-highlight flex-fill" style="padding: 10px;">
                    <div class="d-flex flex-row">
                        <div>
                            <span class="input-group-text" style="background-color: transparent;border: none;padding-left: 0;">Account:</span>
                        </div>
                        <div class="flex-grow-1">
                            <v-select :items="hospitals"
                                      v-model="hospital"
                                      item-text="hosName"
                                      solo
                                      return-object
                                      v-on:change="onHosptialChange"
                                      label="Account">
                            </v-select>
                        </div>
                    </div>
                </div>
                <div class="bd-highlight flex-fill" style="padding: 10px;">
                    <div class="d-flex flex-row">
                        <div>
                            <span class="input-group-text" style="background-color: transparent;border: none;padding-left: 0;">Dictator:</span>
                        </div>
                        <div class="flex-grow-1">
                            <v-select :items="dictators"
                                      v-model="dictator"
                                      item-text="cliName"
                                      solo
                                      return-object
                                      label="Dictator">
                            </v-select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-12" style="padding-top: 0;padding-bottom: 0;">
            <loading :active.sync="loading" :is-full-page="fullPage" color="#016BAB"></loading>
            <v-tabs background-color="indigo" dark>
                <v-tab>
                    Upload Dictations
                </v-tab>
                <v-tab>
                    Record Dictations
                </v-tab>
                <v-tab-item>
                    <v-card>
                        <v-card-text>
                            <div class="row">
                                <div class="col-sm-12" style="padding-top: 0;">
                                    <browse-file ref="browseFiles"
                                                 :on-dialog-close="dialogClose"
                                                 :on-before-upload="onBeforeUpload"
                                                 :on-after-upload="onAfterUpload"
                                                 :on-error-upload="onErrorUpload"
                                                 :hosID="hospital.hosID"
                                                 :cliID="dictator.cliID"
                                                 :hosShortName="hospital.hosShortName"></browse-file>
                                </div>
                                <div class="col-sm-12 text-right">
                                    <v-btn color="primary"
                                           text
                                           @click="browseEvent">
                                        Browse
                                    </v-btn>
                                    <v-btn color="primary"
                                           text
                                           @click="submitFiles" v-bind:disabled="uploadDisabled">
                                        Upload
                                    </v-btn>
                                    <v-btn color="primary"
                                           text
                                           @click="cancelFiles" v-bind:disabled="uploadDisabled">
                                        Cancel
                                    </v-btn>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
                <v-tab-item>
                    <v-card>
                        <v-card-text>
                            <div class="d-flex flex-column">
                                <div class="flex-grow-1">
                                    <record-voice ref="dictation" :hosID="hospital.hosID"
                                                  :hosShortName="hospital.hosShortName"
                                                  :cliID="dictator.cliID"
                                                  :cliName="dictator.cliName"
                                                  :on-recording-change="onRecordingChange"
                                                  :on-before-upload="onBeforeUpload"
                                                  :on-error-upload="onErrorUpload"
                                                  :on-after-upload="onAfterUploadDictations"
                                                  >
                                    </record-voice>
                                </div>
                                <div class="flex-grow-1 text-right">
                                    <v-btn color="primary"
                                           text
                                           @click="uploadRecording" v-bind:disabled="recordingUploadDisabled">
                                        Upload
                                    </v-btn>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-tab-item>
            </v-tabs>
        </div>
    </div>
</template>
<script>
    //uncomment for vuex state management
    //import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
    import axios from 'axios'
    import moment from 'moment'
    import Loading from 'vue-loading-overlay'
    import BrowseFile from './BrowseFile.vue'
    import RecordVoice from './RecordVoice.vue'
    import Swal from 'sweetalert2'
    export default {
        //Your local variables for use in the component
        data() {
            return {
                windowDate: moment().format('dddd, DD MMMM YYYY'),
                loading: false,
                fullPage: true,
                uploadDisabled: true,
                recordingUploadDisabled: true,
                clientID: sessionStorage.getItem('clientID'),
                welcome: sessionStorage.getItem('welcome'),
                warningMessage: "There are recordings waiting to be uploaded. All recordings will be lost if you continue to log off",
                hospitals: [],
                hospital: {},
                dictators: [],
                dictator: {},
                windowTitle: 'Upload - Record | xstek client window',
            };
        },
        beforeMount() {
            window.addEventListener("beforeunload", this.preventNav)
            this.$once("hook:beforeDestroy", () => {
                window.removeEventListener("beforeunload", this.preventNav);
            });
        },
        async created() {
            if (!this.$store.getters.isLoggedIn) {
                let data = {
                    id: this.$route.query.id,
                    cliLogSource: this.$route.query.ref
                };
                if (this.$route.query.ref) {
                    sessionStorage.setItem("externalLogin", this.$route.query.ref);
                } else {
                    sessionStorage.setItem("externalLogin", document.referrer);
                }
                if (data.id) {
                    this.loading = true;
                    this.$store.dispatch('preAuthentication', data).then(() => {
                        window.history.pushState("", this.windowTitle, '/uploadrecord');
                        document.title = "Upload & Record | xstek client window";
                        this.welcome = sessionStorage.getItem('welcome');
                        this.clientID = sessionStorage.getItem('clientID');
                        this.loadHosptials();
                        this.axios.defaults.headers['Authorization'] = `Bearer ${this.$store.state.token}`;
                    }).catch(() => {
                        sessionStorage.setItem("returnUrl", "/uploadrecord");
                        this.$router.push('/login');
                    }).finally(() => {
                        this.loading = false;
                    });
                } else {
                    sessionStorage.setItem("returnUrl", "/uploadrecord");
                    this.$router.push('/login');
                }
                
            } else {
                document.title = this.windowTitle;
                this.axios.defaults.headers['Authorization'] = `Bearer ${this.$store.state.token}`;
                this.loadHosptials();
            }
        },
        //calculated values, auto reactive
        //functionName: function(){}
        //functionName: { get: function() {}, set: function(value){}}
        computed: {

        },
        //perform actions, not reactive to variables used
        //functionName: function(arg1,arg2){}
        methods: {
            preventNav(event) {
                if (this.$refs.dictation.recorded && this.$refs.dictation.recorded.length > 0) {
                    event.preventDefault();
                    event.returnValue = this.warningMessage;
                }
                else {
                    return;
                }
            },
            browseEvent() {
                this.$refs.browseFiles.openBrowseDialog();
            },
            submitFiles() {
                this.$refs.browseFiles.uploadDictations();
            },
            cancelFiles() {
                this.$refs.browseFiles.cancelFiles();
                this.uploadDisabled = true;
            },
            dialogClose(disabled) {
                this.uploadDisabled = disabled;
            },
            onBeforeUpload() {
                this.loading = true;
            },
            onAfterUpload() {
                this.loading = false;
                this.uploadDisabled = true;
            },
            onAfterUploadDictations() {
                this.loading = false;
                this.recordingUploadDisabled = true;
            },
            onErrorUpload() {
                this.loading = false;
            },
            loadHosptials() {
                axios.get('api/transcription/loadhosptials', {
                    params: {
                        cliID: this.clientID,
                        isSec: false
                    }
                }).then((response) => {
                    this.hospitals = response.data.items;
                    let isDefault = false;
                    this.hospitals.forEach((hos) => {
                        if (hos.isDefault && !isDefault) {
                            this.hospital = hos;
                            isDefault = true;
                            return false;
                        }
                    });
                    if (!isDefault && this.hospitals.length > 0) {
                        this.hospital = this.hospitals[0];
                    }
                    this.onHosptialChange();
                }).catch(() => { });
            },
            onHosptialChange() {
                axios.get(`api/transcription/loaddictators`, {
                    params: {
                        cliID: this.clientID,
                        hosID: this.hospital.hosID
                    }
                }).then((response) => {
                    this.dictators = response.data.items;
                    let isFound = false;
                    this.dictators.forEach((dic) => {
                        if (dic.cliID == this.clientID && !isFound) {
                            this.dictator = dic;
                            isFound = true;
                            return false;
                        }
                    });
                    if (!isFound && this.dictators.length > 0) {
                        this.dictator = this.dictators[0];
                    }
                }).catch(() => { });
            },
            onRecordingChange(disabled) {
                this.recordingUploadDisabled = disabled;
            },
            uploadRecording() {
                this.loading = true;
                this.$refs.dictation.uploadDictations();
            },
            logout() {
                if (this.$refs.dictation && this.$refs.dictation.recorded && this.$refs.dictation.recorded.length > 0) {
                    Swal.fire({
                        title: 'Warning!',
                        text: this.warningMessage,
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#016BAB',
                        cancelButtonColor: '#dc3545',
                        confirmButtonText: 'Continue to Log Off',
                        cancelButtonText: 'Cancel'
                    }).then((result) => {
                        if (result.value) {
                            this.$store.dispatch('logout').then((ref) => {
                                if (ref) {
                                    window.location.href = ref;
                                } else {
                                    this.$router.push('/login');
                                }
                            });
                        }
                    });
                } else {
                    this.$store.dispatch('logout').then((ref) => {
                        if (ref) {
                            window.location.href = ref;
                        } else {
                            this.$router.push('/login');
                        }
                    });
                }
            },
        },
        /*  data passed in from external
        propName: {
            type: Number,
            default: 42,
            required: false
            required: false
        }
        */
        props: {

        },
        /* other components need
          you need to import the component first
          'component-a': ComponentA,
        */
        components: {
            Loading, BrowseFile, RecordVoice
        }
    };
</script>
